import React from 'react';
import FeatureCard from './FeatureCard';
import { FiArrowRight, FiAward, FiFileText, FiHeadphones, FiLayers } from 'react-icons/fi';

export default function Features() {
  return (
    <section className="px-4 py-12 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-8 lg:grid-cols-3">
          <div className="col-span-1 rounded-lg bg-[var(--brand-accent)]/10 p-6">
            <p className="text-xs font-semibold uppercase tracking-wide text-[var(--brand-accent-soft)]">Why choose us</p>
            <h2 className="mt-3 text-2xl font-bold text-[var(--brand-ink)]">Everything you need to manage your subscription in one place.</h2>
            <p className="mt-3 text-sm text-[var(--text-muted)]">learnaicare.net offers you a simple way to manage subscriptions, contact agents, and access support from partner-trained teams.</p>
            <div className="mt-6 flex items-center gap-2 text-sm font-semibold text-[var(--brand-accent)]">Reliable service <FiArrowRight className="h-4 w-4" /></div>
          </div>

          <div className="col-span-2 grid gap-6 md:grid-cols-2">
            <FeatureCard title="Simplified management of your subscriptions" icon={<FiLayers />} eyebrow="Management" className="md:col-span-2">
              learnaicare.net offers you to easily manage different subscriptions. Fill in the e-mail address you used when you subscribed and reach your customer account in one click.
            </FeatureCard>

            <FeatureCard title="All the essential information" icon={<FiFileText />} eyebrow="Control">
              All the essential information is there to give you maximum control of your subscriptions. You can also contact the agents to ask for help, unsubscribe or make a complaint.
            </FeatureCard>

            <FeatureCard title="Agents at your service" icon={<FiHeadphones />} eyebrow="Support">
              Our agents are experts in after-sales services and have all the answers to your questions. We work 7 days per week, so you can contact the agents by live chat or by phone.
            </FeatureCard>

            <FeatureCard title="Recognized expertise" icon={<FiAward />} eyebrow="Expertise" className="md:col-span-2">
              We provide the after-sales service of several partner sites, which are all satisfied with our services. Our expertise provides the support for every single client.
            </FeatureCard>
          </div>
        </div>
      </div>
    </section>
  );
}
